import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { FiGlobe, FiSmartphone } from 'react-icons/fi';
import {
  fetchUserLoginHistoryDateWise,
  fetchUserLoginHistoryMonthWise,
} from '../../constants/apiCalls';
import ModalService from '../../services/ModalService';
import { handleErrorMessage } from '../../utils/utils';

import './UserLoginHistory.css';

const UserLoginHistory = ({ user, currentDate, setLoading }) => {
  const [history, setHistory] = useState([]);

  const [activeCount, setActiveCount] = useState(0);
  const [inactiveCount, setInactiveCount] = useState(0);

  useEffect(() => {
    setLoading(true);

    fetchUserLoginHistoryDateWise(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setLoading(false);

          setHistory(data);
        } else if (success === false || success === 'undefined') {
          setLoading(false);

          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      { date: moment(currentDate).format('YYYY-MM-DD'), id: user.id },
    );
  }, [currentDate]);

  useEffect(() => {
    fetchUserLoginHistoryMonthWise(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setActiveCount(Number(data[0].activedays_count || '0'));
          setInactiveCount(Number(data[0].inactivedays_count || '0'));
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        month: moment(currentDate).month() + 1,
        year: moment(currentDate).year(),
        id: user.id,
      },
    );
  }, [currentDate]);

  return (
    <div className="userLoginHistory">
      <div className="loginStats">
        <div>
          <p className="bigLetter">{activeCount + inactiveCount}</p>
          <p className="smallLetter">Working Days</p>
        </div>
        <div>
          <p className="bigLetter green">{activeCount}</p>
          <p className="smallLetter">Active Days</p>
        </div>
        <div>
          <p className="bigLetter red">{inactiveCount}</p>
          <p className="smallLetter">In-Active Days</p>
        </div>
      </div>
      <div className="loginTime">
        <div className="loginTableHeader">
          {moment(currentDate).format('LL')} Login History
        </div>
        <div className="loginTimeTable">
          <table>
            <thead>
              <tr>
                <th style={{ width: '4rem' }}>Sr. No.</th>
                <th style={{ width: '40%' }}>Device</th>
                <th>Time</th>
              </tr>
            </thead>

            <tbody>
              {history.map((data, i) => {
                return (
                  <tr>
                    <td>{i + 1}</td>
                    <td>
                      {data.device_type === 'web' ? (
                        <FiGlobe size="24px" color="blue" />
                      ) : (
                        <FiSmartphone size="24px" color="blue" />
                      )}
                    </td>
                    <td>{data.time_stamp}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {history.length === 0 && <p className="noDataFound">No Data Found</p>}
        </div>
      </div>
    </div>
  );
};

export default UserLoginHistory;
